import React from "react";
import { node, any, shape, string } from "prop-types";
import Link from "@insightfulscience/atomic-react/Link";
import preparePostLink from "../utils/url/preparePostLink";

const RichTextLink = ({ children, data, nodeType, content, ...props }) => {
	const { href } = props;
	const getPreparePostLink = preparePostLink(data?.uri ? data?.uri : href);
	const linkProps = getPreparePostLink.hasTarget
		? {
				target: `_${getPreparePostLink.targetValue}`,
		  }
		: {};
	return (
		<Link href={getPreparePostLink.url} {...linkProps} {...props}>
			{children}
		</Link>
	);
};

RichTextLink.propTypes = {
	data: shape({
		uri: string,
	}),
	nodeType: string,
	content: any, // eslint-disable-line react/forbid-prop-types
	href: string,
	children: node.isRequired,
};

export default RichTextLink;
